export const USERCROWD_NAVBAR_HEIGHT = "3.5rem"
export const USERCROWD_MAX_CONTENT_WIDTH = "75rem"
export const USERCROWD_PAGE_TOP_PADDING = "3.5rem"
export const USERCROWD_PAGE_BOTTOM_PADDING = "4rem"

export const USERCROWD_PAGE_GUTTER_MIN = "1.5rem"
export const USERCROWD_PAGE_GUTTER_MID = "2rem"
export const USERCROWD_PAGE_GUTTER_MAX = "2.5rem"
